/*
  NINI kollekcio gyorslinkek - <nini-quick-links> carousel nyilak.
  A nyilak csak akkor latszanak, ha tobb elem van, mint amennyi elfer.
  Keszitette: Akos | branch: dev/akos | 2026-09-28
*/

(() => {
  class NiniQuickLinks extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.list = this.querySelector('.nini-quick-links__list');
      this.prev = this.querySelector('.nini-quick-links__arrow--prev');
      this.next = this.querySelector('.nini-quick-links__arrow--next');
      if (!this.list || !this.prev || !this.next) return;

      const update = () => {
        const max = this.list.scrollWidth - this.list.clientWidth;
        const position = Math.abs(this.list.scrollLeft);
        const scrollable = max > 1;

        this.prev.hidden = !scrollable;
        this.next.hidden = !scrollable;
        this.prev.disabled = position <= 1;
        this.next.disabled = position >= max - 1;
      };

      [this.prev, this.next].forEach((button) => {
        button.addEventListener('click', () => {
          const rtl = getComputedStyle(this.list).direction === 'rtl';
          const direction = Number(button.dataset.direction) * (rtl ? -1 : 1);
          this.list.scrollBy({ left: direction * this.list.clientWidth, behavior: 'smooth' });
        });
      });

      this.list.addEventListener('scroll', update, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(update).observe(this.list);
      update();
    }
  }

  if (!customElements.get('nini-quick-links')) customElements.define('nini-quick-links', NiniQuickLinks);
})();
